var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeacherFeedbackIcon = function SvgTeacherFeedbackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4EA15A",
    d: "M3 1a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h15l5 5V3a2 2 0 0 0-2-2zm2 11h9v2H5zm0-4h14v2H5zm0-4h14v2H5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#378142",
    d: "M3 1.5c-.414 0-.79.168-1.06.44A1.5 1.5 0 0 0 1.5 3v13c0 .414.168.79.44 1.06.27.272.646.44 1.06.44h15.207l4.293 4.293V3c0-.414-.168-.79-.44-1.06A1.5 1.5 0 0 0 21 1.5z"
  })))));
};
export default SvgTeacherFeedbackIcon;